var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadRemoveFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B7B7C2",
  d: "m15.833 6.138-1.175-1.175L10 9.622 5.342 4.963 4.167 6.138l4.658 4.659-4.658 4.658 1.175 1.175L10 11.972l4.658 4.658 1.175-1.175-4.658-4.658z"
})));
export default SvgUploadRemoveFile;